export default __webpack_public_path__ + "static/media/img13.ecf5350a.png";